$(document).ready(function () {

    //SHOW POSTCODE
    $(document).on('click', '.shipping-identixweb-order-delivery-date', function () {

        showLoader();

        var postCheck = '<div class="added-delivery-identixweb-order-delivery-date" style="margin-bottom: 5px;">\
                            <p class="identixweb-order-delivery-date-uiHeading identixweb-order-delivery-date-local-delivery-Heading">Enter the delivery postcode to check availability.</p>\
                            <div class="order-delivery-date-postalcode-text identixweb-inputWithButton">\
                            <input type="text" placeholder="Enter your postal code ..." class="order-delivery-date-postalcode identixweb-btn-text-input" value="">\
                                <a class="identixweb-snize-exclude-input orderDeliveryDatePostlCode added-orderDeliveryDatePostlCode" style="background-color:#4c347f">\
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\
                                        <path class="cls_strk" d="M14.054 14.0535L20.9998 21" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>\
                                        <path class="cls_strk" d="M8.64706 16.2941C12.8704 16.2941 16.2941 12.8704 16.2941 8.64706C16.2941 4.4237 12.8704 1 8.64706 1C4.4237 1 1 4.4237 1 8.64706C1 12.8704 4.4237 16.2941 8.64706 16.2941Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>\
                                    </svg>\
                                </a>\
                            </div>\
                            <div class="error_msg" style="display: none;color: red !important;font-size: 16px;text-align: center;padding-top: 5px;">Please enter a valid postcode. We currently only deliver SYDNEY WIDE within approx 20km of the CBD.</div>\
                            </div>';

            $('.added-delivery-identixweb-order-delivery-date').remove();
            setTimeout(() => {
                    $('.shipping-identixweb-order-delivery-dates').fadeOut(0);
            }, 500);
            setTimeout(() => {
                    $('.identixweb-order-delivery-date-main').prepend(postCheck);
            }, 300);
            setTimeout(() => {
                $('#loading-spinner').remove();
                $('.identixweb-order-delivery-tab').removeClass("is-loading");
                $('.identixweb-order-delivery-date-main').fadeIn(100);
            }, 500);
            
    });

    $(document).on('click', '.identixweb-order-delivery-tab .local-delivery-identixweb-order-delivery-date', function () {

        showLoader();

            setTimeout(() => {
                    $('.identixweb-order-delivery-date-main .local-delivery-identixweb-order-delivery-date').fadeOut(0);
            }, 100);

            setTimeout(() => {
                $('#loading-spinner').remove();
                $('.identixweb-order-delivery-date-main').fadeIn();
                $('.local-delivery-identixweb-order-delivery-date').fadeIn(50);
                $('.identixweb-order-delivery-tab').removeClass("is-loading");
            }, 500);
            
    });

    function showLoader() {
        $('.identixweb-order-delivery-tab').addClass("is-loading");
        var loader = `<div id="loading-spinner" style="
                        position:relative;
                        top:25px;
                        left:0;
                        width:100%;
                        height:96px;
                        background:rgb(255,255,255);
                        z-index:9999;
                    ">
                        <div style="
                        position:absolute;
                        top:50%;
                        left:50%;
                        width:50px;
                        height:50px;
                        margin-top:-25px;
                        margin-left:-25px;
                        border:4px solid #e5e5e5;
                        border-top:4px solid #000;
                        border-radius:50%;
                        animation:spin 0.8s linear infinite;
                        "></div>
                    </div>
                    `;
        $('<style>')
        .prop('type', 'text/css')
        .html(`
            @keyframes spin {
            100% { transform: rotate(360deg); }
            }
        `)
        .appendTo('head');

        $(loader).insertBefore(".identixweb-order-delivery-date-main");            
        $('.identixweb-order-delivery-date-main').fadeOut(0);
    }

    //CHECK POSTCODE
    var postcodes = [
                    '2000','2006','2007','2008','2009','2010','2011',
                    '2015','2016','2017','2018','2019','2020','2021',
                    '2022','2023','2024','2025','2026','2027','2028',
                    '2029','2030','2031','2032','2033','2034','2035',
                    '2036','2037','2038','2039','2040','2041','2042',
                    '2043','2044','2045','2046','2047','2048','2049',
                    '2193','2203','2204','2205','2206','2207','2216',
                    '2217','2066','2067','2068'
                    ];

    $(document).on('click', '.added-orderDeliveryDatePostlCode', function () {
        var userPostcode = $('.added-delivery-identixweb-order-delivery-date .order-delivery-date-postalcode').val();
        
        if (postcodes.includes(userPostcode)) {
           $('.added-delivery-identixweb-order-delivery-date .order-delivery-date-postalcode-text').removeClass('error'); 
           $('.shipping-identixweb-order-delivery-dates').fadeIn(0);
           //$('.added-delivery-identixweb-order-delivery-date').fadeOut(0);
           $('.added-delivery-identixweb-order-delivery-date .order-delivery-date-postalcode-text').removeClass('error'); 
           $('.error_msg').fadeOut(0);
        } else {
           $('.added-delivery-identixweb-order-delivery-date .order-delivery-date-postalcode-text').addClass('error'); 
           $('.error_msg').fadeIn(0);
           $('.shipping-identixweb-order-delivery-dates').fadeOut(0);
        }
    });
    $(document).on('keypress', '.added-delivery-identixweb-order-delivery-date .order-delivery-date-postalcode', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('.added-orderDeliveryDatePostlCode').trigger('click');
        }
    });
});